<template>
  <div class="products">
    <div class="vat-toggle andfilters">
      <div class="vat-bar">
        <label>Ex. VAT</label>
        <label class="switch" name="">
          <input type="checkbox" :checked="vatToggle" @click="updateVatToggle">
          <span class="slider round"></span>
        </label>
        <label>Inc. VAT</label>
      </div>
      <div class="filter-bar" v-if="products">
        <label for="sortby">Sort:</label>
        <select name="sortby" id="sortby" v-model="sortBy">
          <option value="default">Default</option>
          <option value="asc">Name (a-z)</option>
          <option value="desc">Name (z-a)</option>
          <option value="pasc">Price (lowest)</option>
          <option value="pdesc">Price (highest)</option>
        </select>
      </div> 
    </div>
    <div class="products-wrapper">
      <!---'/images/fit-in/'+product.product_width+'x'+product.product_hight+'/filters:strip_exif()/filters:fill(white)/' + yodahURL + '/uploads/products/' + product.main_image-->
      <a v-for="product in sorted" class="product-div" :href="'/product/'+ product.slug + '/'">
        <div class="product-div-inner">
          <div class="product-item" v-if="product.main_image"><img v-if="product.main_image" class="product-image" width="250" height="175" :src="product.img_src" :alt="product.name" /></div>
          <span class="product-item product-name">{{ product.name | truncate(52, '...') }}</span>
          <p v-if="showDescription" class="product-item product-description">{{ product.short_description | truncate(125, '...') }}</p>
          <p v-if="product.poa == 1" class="product-item product-price">£POA</p>
          <p v-else class="product-item product-price">£{{ ( vatToggle ? product.sale_price * (product.tax_rate/100 + 1) : product.sale_price ) | money}}</p>
          <a class="product-item view-product-btn" :href="'/product/'+ product.slug + '/'">View product</a>
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Select2 from "v-select2-component";
import {mapState} from "vuex";

export default  {
  el: '#products',
  data() {
    return {
      products: [],
      showDescription: jQuery("#data-desc").data("description"),
      sortBy: 'default',
      currentCategoryId: jQuery("#data-cat").data("cat"),
      yodahURL: jQuery('#yodah-url').val(),
    }
  },
  watch: {
    sortBy: function() {
      this.sorted = this.sortedProducts();
    }
  },
  computed: {
    ...mapState(["vatToggle"]),
    sorted: function() {
      return this.sortedProducts();
    }
  },
  methods: {
    updateVatToggle() {
      this.$store.commit('updateVatToggle', !this.vatToggle);
    },
    showProducts: function(filter) {
      let products = this.products;
      for (let i = 0; i < Object.keys(products).length; i++) {
        products[i].show = true;
      }
    },
    getMainImage() {
      for (let i = 0; i < Object.keys(this.products).length; i++) {
        this.products[i].images = JSON.parse(this.products[i].images);
        if (this.products[i].images.length > 0) {
          for (let j = 0; j < this.products[i].images.length; j++) {
            if (this.products[i].images[j].is_main === true) {
              this.products[i].main_image = this.products[i].images[j].name;
            }
          }
          if (!this.products[i].main_image) {
            this.products[i].main_image = this.products[i].images[0].name;
          }
        }else{
          //console.log('No images found for product', this.products[i].id);
        }
      }
    },
    sortedProducts: function() {
    let sortedProducts = [...this.products];    
    console.log('sortedProducts',sortedProducts);
    if (this.sortBy === 'asc') {
      sortedProducts.sort((a, b) => a.name.localeCompare(b.name));
    } else if (this.sortBy === 'desc') {
      sortedProducts.sort((a, b) => b.name.localeCompare(a.name));
    } else if (this.sortBy === 'pasc') {
      sortedProducts.sort((a, b) => a.sale_price - b.sale_price);
    } else if (this.sortBy === 'pdesc') {
      sortedProducts.sort((a, b) => b.sale_price - a.sale_price);
    }
    return sortedProducts;
  }
  },
  mounted() {
    let form_data = new FormData;
    form_data.append('action', 'yodah_category_products_query');
    form_data.append('category', this.currentCategoryId);
    console.log('Form data: ', form_data);
    axios.post(my_ajax_object.ajax_url, form_data)
    .then(response => {
      this.products = response.data.data;
      console.log('Products data', response.data.data);
      this.showProducts();
      this.getMainImage(); 
    }).catch(error => {
      console.log('there was a problem...', error);
    })
  },
};

</script>